// istanbul ignore file - this is a wrapper component for external use
/**
 * Meeting notes form wrapped in MeetingDetailDependenciesProvider.
 * Use this when rendering the notes form outside of meeting detail (e.g. in recaps,
 * standalone modals). The provider supplies useUpdateMeetingMutation and other
 * dependencies required by MeetingNotesForm.
 */
import { MeetingNotesForm } from 'components/meetings/meeting_detail/tabs'

import { MeetingDetailDependenciesProvider } from './meeting_detail_dependencies_provider'

export const MeetingNotesFormWithContext = (props) => (
  <MeetingDetailDependenciesProvider>
    <MeetingNotesForm {...props} />
  </MeetingDetailDependenciesProvider>
)
